import React from "react";

/**
 * Renders an eye filled icon as an SVG element.
 *
 * @param {object} cls - The class name for styling the SVG element.
 * @return {JSX.Element} The rendered SVG eye filled icon.
 */
export const ActionEyeFilledIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M12.0008 14.9966C13.6571 14.9966 14.9997 13.654 14.9997 11.9978C14.9997 10.3415 13.6571 8.99887 12.0008 8.99887C10.3446 8.99887 9.00195 10.3415 9.00195 11.9978C9.00195 13.654 10.3446 14.9966 12.0008 14.9966Z"
        fill="currentColor"
      />
      <path
        d="M20.4501 10.0622C19.2873 8.1684 16.6423 4.99106 12 4.99106C7.35771 4.99106 4.71269 8.1684 3.54987 10.0622C2.81671 11.248 2.81671 12.7464 3.54987 13.9323C4.71269 15.8261 7.35771 19.0034 12 19.0034C16.6423 19.0034 19.2873 15.8261 20.4501 13.9323C21.1833 12.7464 21.1833 11.248 20.4501 10.0622ZM12 16.4956C9.51565 16.4956 7.50166 14.4816 7.50166 11.9972C7.50166 9.51287 9.51565 7.49888 12 7.49888C14.4843 7.49888 16.4983 9.51287 16.4983 11.9972C16.4958 14.4806 14.4833 16.4931 12 16.4956Z"
        fill="currentColor"
      />
    </svg>
  );
};
